import type { NoteSeverity } from "../../types.ts";
import { SEVERITY_LABELS } from "../../utils/severity.ts";
import { SeverityIcon } from "../severity-icon";

export function NoteRowIcon({
	severity,
	stageName,
	onClick,
}: {
	severity: NoteSeverity;
	stageName: string;
	onClick: () => void;
}) {
	return (
		<button
			type="button"
			className="note-row-icon"
			data-severity={severity}
			aria-label={`Alertas de ${stageName}`}
			title={SEVERITY_LABELS[severity]}
			onPointerDown={(event) => event.stopPropagation()}
			onClick={onClick}
		>
			<SeverityIcon severity={severity} />
		</button>
	);
}
